import { Buffer } from 'buffer';
import { CandyMachineV2Program } from './program.mjs';
import { Pda } from '../../types/Pda.mjs';

/** @group Pdas */
const findCandyMachineV2CreatorPda = (candyMachine, programId = CandyMachineV2Program.publicKey) => {
  return Pda.find(programId, [Buffer.from('candy_machine', 'utf8'), candyMachine.toBuffer()]);
};

/** @group Pdas */
const findCandyMachineV2CollectionPda = (candyMachine, programId = CandyMachineV2Program.publicKey) => {
  return Pda.find(programId, [Buffer.from('collection', 'utf8'), candyMachine.toBuffer()]);
};

export { findCandyMachineV2CollectionPda, findCandyMachineV2CreatorPda };
//# sourceMappingURL=pdas.mjs.map
